module.exports = __webpack_public_path__ + "static/media/ahack2.1beb20c6.jpg";